import { getQuartzConfig } from 'quartz-config/evaluable';
const quartzConfig = getQuartzConfig();
if ( /* quartzConfig.type !== 'application' || quartzConfig.deprecated_disableOneDomain !== true */true) {
  // @ts-expect-error untyped global variable
  window.hubspot['__hub-http-labs'] = window.hubspot['__hub-http-labs'] || {};

  // @ts-expect-error untyped global variable
  window.hubspot['__hub-http-labs']['HUBONEDOMAIN'] = true;
}